import { render, staticRenderFns } from "./BalanceMoneyCalculatorStep.vue?vue&type=template&id=75531064&scoped=true"
import script from "./BalanceMoneyCalculatorStep.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyCalculatorStep.vue?vue&type=script&lang=js"
import style0 from "./BalanceMoneyCalculatorStep.vue?vue&type=style&index=0&id=75531064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75531064",
  null
  
)

export default component.exports